import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseurlService } from '../../services/baseurl.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileScanService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getScans(): Observable<FileScanDto[]> {
    return this.http.get<FileScanDto[]>(`${this.baseUrl.getBaseUrl()}/file-scan-status/scans`);
  }

  getScanFiles(scanUid: string, parentDirId?: number): Observable<FileScanFileDto[]> {
    let params = new HttpParams();
    if (parentDirId !== undefined && parentDirId !== null) {
      params = params.set('parentDirId', parentDirId.toString());
    }
    return this.http.get<FileScanFileDto[]>(`${this.baseUrl.getBaseUrl()}/file-scan-status/scanFiles/${scanUid}`, { params });
  }
}

export interface FileScanDto {
  stracliHost: string;
  scanUid: string;
  scanFirstReceivedTime: string;
  scanLastReceivedTime: string;
  initialDir: string | null;
}

export interface FileScanFileDto {
  id: number;
  path: string;
  type: string;
  size: number | null;
  sha256: string | null;
  scannedAt: string;
  modifiedAt: string | null;
}
